// extracted by mini-css-extract-plugin
export var container = "_7a-0";
export var icon = "_7a-1";
export var text = "_7a-2";